import {Component, OnInit} from '@angular/core';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-vat-report',
  templateUrl: './vat-report.component.html',
  styleUrls: ['./vat-report.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent
  ]
})
export class VatReportComponent implements OnInit {
  user_rights: any;
  user_data: any;

  stock_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date();
  todate = new Date();
  start: any;
  limit: any;

  constructor(private loaderService: LoaderService, public rest: ConsultingService, public report: ReportService,) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date(this.todate.getFullYear(), this.todate.getMonth() + 1, 0, 23, 59, 59);
    this.listVatReport();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listVatReport() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.listVatReport(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'success') {
        this.stock_data = result['data'];
        this.BalVatamount();
      } else {
        this.stock_data = []
      }
    });
  }

  public BalVatamount() {
    let i = 0
    for (const data of this.stock_data) {
      const vat = (data.SELLING_QUANTITY * data.PURCHASE_PRICE * data.VAT / 100).toFixed(2);
      const pur_vat = (parseFloat(vat)).toFixed(2);
      const sale_vat = (parseFloat(data.SALE_VAT_AMOUNT)).toFixed(2);
      data["VAT_AMOUNT"] = vat;
      data["PURCHASE_VAT"] = pur_vat;
      data["SALE_VAT"] = sale_vat;
      data["BALANCE_VAT"] = (parseFloat(sale_vat) - parseFloat(pur_vat));
      this.stock_data[i] = data;
      i = i + 1;
    }
  }

}
